import clsx from "clsx";
import { MISSING_VALUE, formatDateTime, formatRelativeTime, parseDate } from "@/lib/format";
import { useNow } from "@/lib/hooks";
import { Tooltip } from "../Tooltip/Tooltip";
import styles from "./RelativeTime.module.css";

export interface RelativeTimeProps {
  /** An ISO date-time (or date) from the API. */
  value: string | Date | null | undefined;
  className?: string;
}

/** "3 days ago", with the absolute date and time in a tooltip (focusable, so keyboards reach it too). */
export function RelativeTime({ value, className }: RelativeTimeProps) {
  const now = useNow(30_000);
  const date = parseDate(value);
  if (date === null) return <span className={clsx(styles.missing, className)}>{MISSING_VALUE}</span>;
  return (
    <Tooltip content={formatDateTime(date)}>
      <button type="button" className={clsx(styles.trigger, className)}>
        <time dateTime={date.toISOString()}>{formatRelativeTime(date, { now: new Date(now) })}</time>
      </button>
    </Tooltip>
  );
}
